//imports
import {
    MAINTENANCE_WARNINGS_DETAILS_OPEN_MODAL,
    MAINTENANCE_WARNINGS_DETAILS_REQUEST,
    MAINTENANCE_WARNINGS_DETAILS_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: {},
    data: null,
    total: 0
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MAINTENANCE_WARNINGS_DETAILS_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, data: action.payload.data }

        case MAINTENANCE_WARNINGS_DETAILS_REQUEST:
            return { ...state, loading: true }

        case MAINTENANCE_WARNINGS_DETAILS_RESULT:
            return { ...state, loading: false, result: action.payload.data }

        case CLEAR_REDUX:
            return ["", "MAINTENANCE_WARNINGS_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};